/*
 * Lib Module TabMenu
 */

Lib.TabMenu = (function() {
    var self = {};

    $(Lib).on('document.ready', function() {
        self.initializeTabMenu($('ul[data-tabmenu]'));
        self.cardTabmenu($('.card ul.tab-menu'));
    });

    /**
     * Initialize tab menus
     * TODO: Document how to use this properly
     * @param tablist
     */
    self.initializeTabMenu = function(tablist) {
        tablist.on('click', 'a[href^="#"]', function(e) {
            e.preventDefault();
            var href = $(this).attr('href').split('#')[1];
            // Find the current tab menu
            var tabMenu = $(this).closest('[data-tabmenu]');

            // The tab ID
            var tabIdentifier = tabMenu.data('tabmenu');

            // Get the tab container
            var tabContainer = $('div[data-tabcontent=\'' + tabIdentifier + '\']');

            // Hide the initial div
            tabContainer.find('> [data-tabinitial]').first().hide();

            // The target tab to show
            var target = $('div[data-tab=\'' + href + '\']', tabContainer);

            // Remove the active class from the tab links
            tabMenu.find('a[href^="#"]').parent().removeClass('active');

            // Add the active class
            $(this).parent().addClass('active');

            // Hide all tabs
            tabContainer.find('> [data-tab]').not(target).hide();

            // And show the right one
            target.show();

            // Trigger an event on the lib so other modules can use this
            $(Lib).trigger('tab.switch', [{target: target}]);
        });
    };

    self.cardTabmenu = function(elTab) {

        if (elTab.find('>li>a').length > 1) {

            elTab.find('a.active').on('click', function(e) {

                if (Lib.Responsive.is(['xs', 'sm', 'md'])) {

                    var cardParent = $(this).closest('.card');
                    if (cardParent.hasClass('tab-menu-open')) {

                        Lib.Stick.resetStickyHeight();
                        $('.clickmask').hide();

                    } else {

                        e.preventDefault();
                        $('.clickmask').show();
                        cardParent.addClass('tab-menu-open');
                    }

                }
            });
        }
        $(document).on('click touchstart', '.card.tab-menu-open .card-content', function() {
            $('div.clickmask').trigger('click');
        });
    };

    return self;

})();
